import moment from 'moment';
import React, { Component } from 'react';
import { Alert, ControlLabel, FormGroup, Row, Col, FormControl, } from 'react-bootstrap';
import { Dialog, DialogContent, DialogHeader, DialogTitle, Button, } from '@cargomatic/ui';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { getLocationUpdates } from 'components/modules/booking/BookingHelper';
import { intentMap } from 'utils/formatters/stops';
import stopIntentTypes from 'config/stop-intent-types';
import CargomaticInput from 'components/v2/input';
import Location from 'components/modules/booking/Location';
import LocationContact from 'components/modules/booking/LocationContact';
import TimeWindow from 'components/time/TimeWindow';
import XIcon from 'components/v2/icons/XIcon';
import { sluggify } from 'utils/localization/utils';
import { Tab } from '@headlessui/react';
import LoadDetailsForm from 'components/load/LoadDetailsForm';
import { defaultLoad } from 'utils/localization/types';
import { withLocaleContext } from 'providers/locale-settings-context';
import Tabs from 'components/v2/navs/Tabs';
import Checkbox from 'components/v2/forms/Checkbox';
import { validateLoadItem } from 'helpers/booking/validation';
import { isDrayageShipment } from 'helpers/shipment-types';
import { isProd } from 'helpers/helper_functions';
import AlertComponent from 'components/ui/Alert';
import YardStopForm from './YardStopForm';
function getTimeWindow(timezone) {
    const now = moment();
    let windowNow = now.clone();
    if (timezone) {
        windowNow = windowNow.tz(timezone);
    }
    const windowStart = windowNow.add('minutes', 30 - (now.minute() % 30));
    const window_start = windowStart.toISOString();
    const window_end = windowStart.add('hours', 2).toISOString();
    return {
        window_start,
        window_end,
    };
}
function getNewLoad(defaultLoadData) {
    return Object.assign({}, defaultLoadData);
}
function getInitialState() {
    return Object.assign({ error: {}, action: '', location: {
            name: '',
            address: {
                label: '',
            },
            lat: null,
            lng: null,
            suite_or_apt: '',
        }, loads: [], contact: {}, off_site: false, full_truckload: false }, getTimeWindow());
}
const getTabs = (t, isDrayageShipment) => {
    return [
        {
            name: React.createElement("div", { "data-testid": "addShipmentStop" }, t('ADD_SHIPMENT_STOP')),
        },
        ...(isDrayageShipment
            ? [
                {
                    name: React.createElement("div", { "data-testid": "addYardtStop" }, t('ADD_YARD_STOP')),
                },
            ]
            : []),
    ];
};
class AddStopModal extends Component {
    constructor(props) {
        super(props);
        this.handleActionChange = (e) => {
            this.setState({
                action: e.target.value,
            });
        };
        this.addLoad = (newLoads) => {
            this.setState({ loads: newLoads });
        };
        this.handleRemoveLoad = (newLoads, index) => {
            this.setState({ loads: newLoads });
        };
        this.handleLoadFieldChange = (newLoads, field, value, index) => {
            this.setState({ loads: newLoads });
        };
        this.handleToggleFullTruckLoad = (full_truckload) => {
            const localeData = this.props.localeData;
            this.setState(() => {
                if (full_truckload) {
                    return {
                        full_truckload,
                        loads: [],
                    };
                }
                return {
                    full_truckload: false,
                    loads: [
                        getNewLoad(Object.assign(Object.assign({}, defaultLoad), localeData)),
                    ],
                };
            }, this.requestQuote);
        };
        this.handleLocationFieldChange = (field, value) => {
            this.setState((prevState) => {
                const location = Object.assign(Object.assign({}, prevState.location), { [field]: value });
                return Object.assign(Object.assign({}, prevState), { location });
            });
        };
        // Locations
        this.handleLocationNameSelect = (selectedLocation) => {
            const location = getLocationUpdates(selectedLocation);
            this.setState({ location });
        };
        this.handleLocationAddressSelect = (item) => {
            const { label, location } = item;
            const { lat, lng } = location;
            const coords = [lng, lat];
            this.setState((prevState) => {
                const locationData = Object.assign(Object.assign({}, prevState.location), {
                    address: {
                        label,
                        location,
                    },
                    coords,
                });
                return Object.assign(Object.assign({}, prevState), { location: locationData });
            });
        };
        this.handleLocationContactChange = (attribute, value) => {
            const contact = Object.assign({}, this.getContact());
            contact[attribute] = value;
            this.setState({ contact });
        };
        this.handleTimeWindowOpenChange = (timeStamp) => {
            this.setState({ window_start: timeStamp });
        };
        this.handleTimeWindowCloseChange = (timeStamp) => {
            this.setState({ window_end: timeStamp });
        };
        this.handleOffSiteChange = (off_site) => {
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { off_site });
            });
        };
        this.handleSaveClick = () => {
            const error = this.validate();
            if (Object.keys(error).length === 0) {
                const { location: { address: { label: address }, name, suite_or_apt, lat, lng, }, window_start, window_end, loads, off_site, } = this.state;
                const stop = {
                    window_start,
                    window_end,
                    action: intentMap[this.state.action].action,
                    empty: intentMap[this.state.action].empty,
                    location: {
                        address,
                        name,
                        suite_or_apt,
                        lat,
                        lng,
                    },
                    loads,
                    off_site,
                };
                this.props.onSave(stop);
            }
        };
        this.state = getInitialState();
        this.isDrayageShipment = isDrayageShipment(this.props.shipment);
    }
    getContact() {
        return this.state.contact;
    }
    getValidationState(key) {
        const { error } = this.state;
        if (Object.prototype.hasOwnProperty.call(error, key)) {
            return 'error';
        }
        return null;
    }
    validate() {
        const error = {};
        const { action, loads, location: { name, address }, } = this.state;
        const { t } = this.props;
        if (!action) {
            error.action = t('INTENT_IS_REQUIRED_ERROR');
        }
        else {
            const { shipment: { stops }, } = this.props;
            const otherActions = stops.map((s) => s.action);
            const actions = [...otherActions, action];
            if (!actions.includes('pickup') || !actions.includes('deliver')) {
                error.action = t('MINIMUM_STOP_ERROR');
            }
        }
        if (!name) {
            error.name = t('LOCATION_IS_REQUIRED_ERROR');
        }
        if (!address || !address.label) {
            error.address = t('ADDRESS_FROM_LIST_ERROR');
        }
        let loadValid = true;
        let loadErrors = [];
        loads.forEach((load) => {
            const loadError = validateLoadItem(Object.assign(Object.assign({}, load), { t }));
            if (Object.keys(loadError).length > 0) {
                loadValid = false;
                loadErrors = loadErrors.concat(Object.values(loadError));
            }
        });
        if (!loadValid) {
            error.loads = loadErrors[0];
        }
        this.setState({ error });
        return error;
    }
    renderIntentDropdown() {
        const { t } = this.props;
        const { action } = this.state;
        return (React.createElement(FormGroup, { validationState: this.getValidationState('action') },
            React.createElement(FormControl, { componentClass: "select", onChange: this.handleActionChange },
                React.createElement("option", { value: "" }, t('SELECT_INTENT')),
                stopIntentTypes.map((item) => {
                    const selected = action === item.slug;
                    return (React.createElement("option", { key: item.slug, value: item.slug, selected: selected }, t(item.localizationSlug)));
                }))));
    }
    renderErrors() {
        const { error } = this.state;
        const errorKeys = Object.keys(error);
        const hasErrors = errorKeys.length > 0;
        const { t, shipment } = this.props;
        if (hasErrors) {
            return (React.createElement(Alert, { bsStyle: "danger" },
                React.createElement("ul", null, errorKeys.map((key) => (React.createElement("li", null, error[key]))))));
        }
        if (shipment.carrier && shipment.carrier.portpro) {
            const { carrier: { portpro: { enabled: portProEnabled }, }, } = shipment;
            if (portProEnabled) {
                return (React.createElement(AlertComponent, { className: "mt-2", type: "warning", title: t('ADD_STOP_PORTPRO_WARNING') }));
            }
        }
        return null;
    }
    renderShipmentStopTab() {
        const { t } = this.props;
        const { action, location } = this.state;
        const label = t(sluggify(action || ''));
        const contact = this.getContact();
        return (React.createElement("div", { className: "add-stop__form" },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 }, this.renderErrors())),
            React.createElement("fieldset", null,
                React.createElement("legend", null, t('LOCATION_INTENT')),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 3 },
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 12 },
                                React.createElement(ControlLabel, null, t('SELECT_INTENT')),
                                this.renderIntentDropdown())),
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 12 },
                                React.createElement(Checkbox, { id: "off_site_checkbox", checked: this.state.off_site, onChange: this.handleOffSiteChange }, t('IS_OFFSITE'))))),
                    React.createElement(Col, { md: 9 },
                        React.createElement(Location, { label: label, onChange: this.handleLocationFieldChange, onNameSelect: this.handleLocationNameSelect, onAddressSelect: this.handleLocationAddressSelect, location: location, onRemoveLocation: () => { } }),
                        React.createElement(LocationContact, { contact: contact, onContactChange: this.handleLocationContactChange })))),
            React.createElement("fieldset", null,
                React.createElement("legend", null, t('TIME_WINDOW')),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 9, mdOffset: 3 },
                        React.createElement(FormGroup, null,
                            React.createElement(TimeWindow, { startTimeLabel: t('READY_TIME'), open: this.state.window_start, close: this.state.window_end, onWindowOpenChange: this.handleTimeWindowOpenChange, onWindowCloseChange: this.handleTimeWindowCloseChange }))))),
            React.createElement("fieldset", null,
                React.createElement("legend", null, t('LOAD_DETAILS')),
                React.createElement(Row, { className: "form-row" },
                    React.createElement(Col, { md: 12 },
                        React.createElement(CargomaticInput, { className: "my-4", type: "checkbox", id: "full_truckload", label: t('FULL_TRUCKLOAD'), info: t('FULL_TRUCKLOAD_NOTE'), value: this.state.full_truckload, onChange: this.handleToggleFullTruckLoad }),
                        React.createElement(LoadDetailsForm, { loadOnly: true, loads: this.state.loads, fullTruckload: this.state.full_truckload, addLoad: this.addLoad, onRemoveLoad: this.handleRemoveLoad, onLoadFieldChange: this.handleLoadFieldChange, onTotalShipmentWeightChange: () => { } })))),
            React.createElement("div", { className: "flex justify-end gap-3" },
                React.createElement(Button, { variant: "outline", onClick: () => {
                        this.setState(getInitialState());
                        this.props.onClose();
                    } }, t('CANCEL')),
                React.createElement(Button, { onClick: this.handleSaveClick }, titleize(t('SAVE'))))));
    }
    renderYardStopsTab() {
        return (React.createElement(YardStopForm, { shipment: this.props.shipment, onClose: () => {
                this.setState(getInitialState());
                this.props.onClose();
            } }));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Dialog, { open: this.props.show, onOpenChange: this.props.onClose },
            React.createElement(DialogContent, { className: "w-screen h-screen max-w-none max-h-none overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, t('ADD_STOP'))),
                React.createElement("div", { "data-testid": "addStopModalBody" },
                    React.createElement(Tabs, { tabs: getTabs(t, this.isDrayageShipment) },
                        React.createElement(Tab.Panel, null,
                            React.createElement("div", { "data-testid": "addShipmentStopBody" }, this.renderShipmentStopTab())),
                        React.createElement(Tab.Panel, null, this.isDrayageShipment && (React.createElement("div", { "data-testid": "addYardStopBody" }, this.renderYardStopsTab()))))))));
    }
}
AddStopModal.propTypes = {
    show: PropTypes.bool,
    shipment: PropTypes.shape({
        stops: PropTypes.arrayOf(PropTypes.shape({
            action: PropTypes.string,
        })),
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
AddStopModal.defaultPropTypes = {
    show: false,
};
export default withTranslation()(withLocaleContext(AddStopModal));
